import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import history from './history';
import App from './App';
import * as serviceWorker from './serviceWorker';

import axios from 'axios';

// These settings are required for sending the access token cookie with all requests and
// setting the CSRF header correctly when calling the API. These will need to be overridden
// if calling other APIs (such as google maps api).
axios.defaults.withCredentials = true
axios.defaults.xsrfCookieName = 'csrf_access_token'
axios.defaults.xsrfHeaderName = 'X-CSRF-TOKEN'

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error && error.response && error.response.status === 401) {
      history.push('/');
    }
    return Promise.reject(error);
  });

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
